import { Outlet } from 'react-router-dom';

import { useOnFeatureClearingStates } from '../../../../shared/hooks/use-on-feature-clearing-states/use-on-feature-clearing-states.hook';
import { useRouteRedirect } from '../../../../shared/hooks/use-route-redirect/use-route-redirect.hook';
import Container from '../../../shared/components/ui/Container/Container';
import { clearAppsState, clearFilters } from '../../store/slices/apps.slice';
import { releasesActions } from '../../store/slices/releases.slice';

const Apps = () => {
  useOnFeatureClearingStates([
    clearFilters(),
    clearAppsState(),
    releasesActions.resetReleasesSliceState(),
  ]);

  useRouteRedirect('/appstore', '/appstore/all-apps');

  return (
    <Container
      data-testid="appstore-landing-page"
      maxWidth={false}
      sx={{
        mt: 3,
        mr: 'unset',
        ml: 'unset',
        boxSizing: 'unset',
        padding: 0,
        ['@media(min-width: 600px)']: {
          padding: 0,
        },
      }}
    >
      <Outlet />
    </Container>
  );
};

export default Apps;
